window.App.UserAgent = {
    IsAndroid: !!navigator.userAgent.match(/Android/i),
    IsIOS: !!navigator.userAgent.match(/(iPod|iPhone|iPad)/i)
};